import React from "react";
import { motion } from "framer-motion";

const scrollReveal = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const staggerContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.2 } },
};

const WhyChooseUs = () => {
    const cardData = [
        {
            title: "Personalized Partner Attention",
            description: "Partner-Led Attention with direct senior partner involvement.",
            icon: "fa-handshake",
        },
        {
            title: "Agile and Fast Service",
            description: "Agility with faster turnaround times than traditional firms.",
            icon: "fa-rocket",
        },
        {
            title: "Expertise Across Industries",
            description: "Industry Expertise across Healthcare, IT, Manufacturing, and E-commerce.",
            icon: "fa-industry",
        },
    ];


    return (
        <motion.div
            className="wcu-main-smco"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
        >
            <motion.h2 className="sections-title-smco" variants={scrollReveal}>
                <span className="horizontal-line"></span>Why Choose Us
            </motion.h2>

            <motion.div className="wcu-container-smco" variants={staggerContainer} style={{ marginTop: "30px" }}>
                <motion.div className="wcu-grid-smco" variants={staggerContainer}>
                    {cardData.map((item, index) => (
                        <motion.div key={index} className="wcu-card-smco" variants={scrollReveal}>
                            {/* Semi-circle Background */}
                            <motion.div className="wcu-semicircle-smco" variants={scrollReveal}></motion.div>

                            {/* Icon using <i> tag */}
                            <motion.div className="wcu-icon-container-smco" variants={scrollReveal}>
                                <i className={`fa ${item.icon} wcu-icon-smco`}></i>
                            </motion.div>

                            {/* Title */}
                            <motion.h3 className="wcu-title-smco" variants={scrollReveal}>{item.title}</motion.h3>

                            {/* Description */}
                            <motion.p className="wcu-description-smco" variants={scrollReveal}>{item.description}</motion.p>
                        </motion.div>
                    ))}
                </motion.div>
            </motion.div>
        </motion.div>
    );
};

export default WhyChooseUs;
